module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\n// prepare usedPermissions\nlet usedPermissions = { read: true, write: true, }\nif(resourceData.usedPermissions){\nusedPermissions = resourceData.usedPermissions\n} else if(resourceData.permissions){\nusedPermissions = {\nread: \tutils.permissions.hasAccessTo(storage, resourceData.permissions, 'read', scope, 'cms_media'),\nwrite: \tutils.permissions.hasAccessTo(storage, resourceData.permissions, 'write', scope, 'cms_media'),\n}\n}\nlet disabled = false\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled\n}\nconst additionalClasses = []\nif(disabled)                        additionalClasses.push('disabled');\nif(resourceData.isNew)              additionalClasses.push('isNew');\nif(resourceData.delete)             additionalClasses.push('delete');\nlet fileSymbol = ''\nlet fileTitle = ''\nlet fileName = ''\nif(model.extendedButtonActionsGranted){\nfileTitle = '# ' + (resourceData.mediaID || '') + ' - '\n}\nif(resourceData.missingMainDBEntry){\nadditionalClasses.push('missingMainDBEntry')\nfileSymbol = 'fi fi-exclamation-triangle'\nfileTitle += storage.__('error:fileManagement.missingMainDBEntry.title')\n} else if(!usedPermissions.read){\nadditionalClasses.push('permissionsDenied')\nfileSymbol = 'fi fi-shield'\nfileTitle += storage.__('error:fileManagement.permissionsDenied.title')\n} else if(!resourceData.mediaID) {\nadditionalClasses.push('placeholder')\nfileTitle = storage.__('hint.fileField.placeholder')\nfileName = fileTitle\n} else {\nfileSymbol = utils.media.file.getSymbolClass(resourceData.extension)\nfileTitle += (resourceData.url || '')\nfileName = resourceData.originalName || ''\n}\nlet controls = {\ncopyToClipboardUrl: usedPermissions.read && !config.slimControls,\nassignTags:         usedPermissions.write && !config.slimControls,\ndownload:           usedPermissions.read,\ndelete:             usedPermissions.write,\n}\nif(resourceData.missingMainDBEntry){\ncontrols = {\ndelete: usedPermissions.write\n}\n} else {\nif(config.controls === false){\ncontrols = false\n}\nelse {\nfor(var command in config.controls){\nif(config.controls[command] === false){\ncontrols[command] = false\n}\n}\n}\n}\n// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.\nconst url = resourceData.url || ''\nconst thumb = resourceData.thumb || ''\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-media-id=\"<%- resourceData.mediaID %>\" data-media-index=\"<%- resourceData.index %>\" title=\"<%= fileTitle %>\"><%\n%><div class=\"new\"><%\n%><i class=\"fi fi-file-new\"></i><%\n%></div><%\n%><div class=\"status\"><%\n%><i class=\"delete fi fi-trash\"></i><%\n%></div><%\nif(controls){\n%><div class=\"controls\"><%\nif(\nusedPermissions.read && (\n((resourceData.permissions || {}).public || {}).read === false ||\n!resourceData.isReusable\n)\n){\n%><div class=\"mediaProperties\"><%\nif(((resourceData.permissions || {}).public || {}).read === false){\n%><div class=\"restricted\"><i class=\"fi fi-shield\"></i></div><%\n}\nif(!resourceData.isReusable){\n%><div class=\"nonReusable\"><i class=\"fi fi-coffee\"></i></div><%\n}\n%></div><%\n}\nif(controls.copyToClipboardUrl){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl', context: 'media-file', mode: config.context, symbolOnly: true, icon: 'fi fi-copy-to-clipboard' } }) %><%\n}\nif(controls.assignTags){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign', context: 'tags', mode: config.context, symbolOnly: true, icon: 'fi fi-mediaFileDetails' } }) %><%\n}\nif(controls.download){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'download', context: 'media-file', mode: config.context, symbolOnly: true } }) %><%\n}\nif(controls.delete){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', mode: config.context, symbolOnly: true } }) %><%\n}\n%></div><%\n}\n%><div class=\"symbol <%- fileSymbol %>\" title=\"<%= fileTitle %>\"></div><%\n%><div class=\"file\" title=\"<%= fileTitle %>\"><%= fileName %></div><%\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\media\\file\\file.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
// prepare usedPermissions
let usedPermissions = { read: true, write: true, }
if(resourceData.usedPermissions){
usedPermissions = resourceData.usedPermissions
} else if(resourceData.permissions){
usedPermissions = {
read: 	utils.permissions.hasAccessTo(storage, resourceData.permissions, 'read', scope, 'cms_media'),
write: 	utils.permissions.hasAccessTo(storage, resourceData.permissions, 'write', scope, 'cms_media'),
}
}
let disabled = false
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled
}
const additionalClasses = []
if(disabled)                        additionalClasses.push('disabled');
if(resourceData.isNew)              additionalClasses.push('isNew');
if(resourceData.delete)             additionalClasses.push('delete');
let fileSymbol = ''
let fileTitle = ''
let fileName = ''
if(model.extendedButtonActionsGranted){
fileTitle = '# ' + (resourceData.mediaID || '') + ' - '
}
if(resourceData.missingMainDBEntry){
additionalClasses.push('missingMainDBEntry')
fileSymbol = 'fi fi-exclamation-triangle'
fileTitle += storage.__('error:fileManagement.missingMainDBEntry.title')
} else if(!usedPermissions.read){
additionalClasses.push('permissionsDenied')
fileSymbol = 'fi fi-shield'
fileTitle += storage.__('error:fileManagement.permissionsDenied.title')
} else if(!resourceData.mediaID) {
additionalClasses.push('placeholder')
fileTitle = storage.__('hint.fileField.placeholder')
fileName = fileTitle
} else {
fileSymbol = utils.media.file.getSymbolClass(resourceData.extension)
fileTitle += (resourceData.url || '')
fileName = resourceData.originalName || ''
}
let controls = {
copyToClipboardUrl: usedPermissions.read && !config.slimControls,
assignTags:         usedPermissions.write && !config.slimControls,
download:           usedPermissions.read,
delete:             usedPermissions.write,
}
if(resourceData.missingMainDBEntry){
controls = {
delete: usedPermissions.write
}
} else {
if(config.controls === false){
controls = false
}
else {
for(var command in config.controls){
if(config.controls[command] === false){
controls[command] = false
}
}
}
}
// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.
const url = resourceData.url || ''
const thumb = resourceData.thumb || ''

    ; __line = 68
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-media-id=\"")
    ; __append( resourceData.mediaID )
    ; __append("\" data-media-index=\"")
    ; __append( resourceData.index )
    ; __append("\" title=\"")
    ; __append(escapeFn( fileTitle ))
    ; __append("\">")
    ; 

    ; __line = 69
    ; __append("<div class=\"new\">")
    ; 

    ; __line = 70
    ; __append("<i class=\"fi fi-file-new\"></i>")
    ; 

    ; __line = 71
    ; __append("</div>")
    ; 

    ; __line = 72
    ; __append("<div class=\"status\">")
    ; 

    ; __line = 73
    ; __append("<i class=\"delete fi fi-trash\"></i>")
    ; 

    ; __line = 74
    ; __append("</div>")
    ; 
if(controls){

    ; __line = 76
    ; __append("<div class=\"controls\">")
    ; 
if(
usedPermissions.read && (
((resourceData.permissions || {}).public || {}).read === false ||
!resourceData.isReusable
)
){

    ; __line = 83
    ; __append("<div class=\"mediaProperties\">")
    ; 
if(((resourceData.permissions || {}).public || {}).read === false){

    ; __line = 85
    ; __append("<div class=\"restricted\"><i class=\"fi fi-shield\"></i></div>")
    ; 
}
if(!resourceData.isReusable){

    ; __line = 88
    ; __append("<div class=\"nonReusable\"><i class=\"fi fi-coffee\"></i></div>")
    ; 
}

    ; __line = 90
    ; __append("</div>")
    ; 
}
if(controls.copyToClipboardUrl){

    ; __line = 93
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl', context: 'media-file', mode: config.context, symbolOnly: true, icon: 'fi fi-copy-to-clipboard' } }) )
    ; 
}
if(controls.assignTags){

    ; __line = 96
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign', context: 'tags', mode: config.context, symbolOnly: true, icon: 'fi fi-mediaFileDetails' } }) )
    ; 
}
if(controls.download){

    ; __line = 99
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'download', context: 'media-file', mode: config.context, symbolOnly: true } }) )
    ; 
}
if(controls.delete){

    ; __line = 102
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-file', mode: config.context, symbolOnly: true } }) )
    ; 
}

    ; __line = 104
    ; __append("</div>")
    ; 
}

    ; __line = 106
    ; __append("<div class=\"symbol ")
    ; __append( fileSymbol )
    ; __append("\" title=\"")
    ; __append(escapeFn( fileTitle ))
    ; __append("\"></div>")
    ; 

    ; __line = 107
    ; __append("<div class=\"file\" title=\"")
    ; __append(escapeFn( fileTitle ))
    ; __append("\">")
    ; __append(escapeFn( fileName ))
    ; __append("</div>")
    ; 

    ; __line = 108
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\media\file\file.ejs

}